// client/src/components/Admin/AlertManager.js
import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import SweetAlert from "react-bootstrap-sweetalert";
import { ALERT_OVERRIDES } from "../../constants/adminConstants";
import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

const useStylesAlert = makeStyles(stylesAlert);

const AlertManager = ({ alert, setAlert }) => {
  const classes = useStylesAlert();

  const hideAlert = () => setAlert(null);

  if (!alert) return null;

  const alertProps = {
    style: ALERT_OVERRIDES,
    title: alert.title,
    onConfirm: alert.onConfirm || hideAlert,
    confirmBtnCssClass: `${classes.button} ${classes.success}`,
    children: alert.message,
  };

  if (alert.type === "success") {
    alertProps.success = true;
  } else if (alert.type === "error") {
    alertProps.danger = true;
    alertProps.confirmBtnCssClass = `${classes.button} ${classes.danger}`;
  } else if (alert.type === "warning") {
    alertProps.warning = true;
    alertProps.onCancel = alert.onCancel || hideAlert;
    alertProps.cancelBtnCssClass = `${classes.button} ${classes.danger}`;
    alertProps.showCancel = true;
    alertProps.confirmBtnText = alert.confirmText || "Yes, proceed!";
    alertProps.cancelBtnText = alert.cancelText || "Cancel";
  }

  return <SweetAlert {...alertProps} />;
};

AlertManager.propTypes = {
  alert: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
  }),
  setAlert: PropTypes.func.isRequired,
};

export default AlertManager;

